import { ApolloError } from '@apollo/client';
import { events as schemaEvents } from './schemas';
import apiClient from './apiClient';
import EventsDataStore from '../../datastores/EventsDataStore';

class EventsDataStoreGraphQL implements EventsDataStore {
  client = apiClient();

  async getEventsByStudent(eventType: string) {
    try {
      const response = await this.client.query({
        query: schemaEvents.getEventsByStudent,
        variables: { eventType }
      });
      const { eventsType } = response.data?.eventsReservation || {};
      return eventsType;
    } catch (error) {
      throw new Error('error getEventsByStudent');
    }
  }

  async getEventsByStudentScroll(
    eventType: string,
    page: number,
    career: string,
    campus: string
  ) {
    try {
      const response = await this.client.query({
        query: schemaEvents.getEventsByTypeScroll,
        variables: { eventType, page, career, campus }
      });
      const { eventsReservation } = response.data || {};
      return eventsReservation;
    } catch (error) {
      throw new Error('error getEventsByStudentScroll');
    }
  }

  async getEventDetail(eventId: number, campus: string, modality: string) {
    try {
      const response = await this.client.query({
        query: schemaEvents.getEventDetail,
        variables: { eventId, campus, modality }
      });
      const { eventByIdPortal } = response.data.eventsReservation || {};
      return eventByIdPortal;
    } catch (error) {
      throw new Error('error getEventsByStudent');
    }
  }

  async getPenalties(period: string) {
    try {
      const response = await this.client.query({
        query: schemaEvents.getPenalties,
        variables: { period }
      });
      const { penalties } = response.data.eventsReservation;
      return penalties;
    } catch (error) {
      throw new Error('error getEventsByStudent');
    }
  }

  async setEventInscription(eventId: number) {
    try {
      const response = await this.client.mutate({
        mutation: schemaEvents.setEventInscription,
        variables: { eventId }
      });
      return response?.data?.subscribeEvent;
    } catch (error) {
      throw new Error('error setEventInscription...');
    }
  }

  async setEventUnsubscribe(eventId: number) {
    try {
      const response = await this.client.mutate({
        mutation: schemaEvents.setEventUnSubscribe,
        variables: { eventId }
      });
      return response?.data?.unSubscribeEvent;
    } catch (error) {
      throw new Error('error setEventUnsubscribe');
    }
  }

  async registerWaitingList(eventId: number, periodId: string) {
    try {
      const response = await this.client.mutate({
        mutation: schemaEvents.subscribeToWaitingList,
        variables: { eventId, periodId }
      });
      return response?.data?.subscribeToWaitingList;
    } catch (error) {
      throw new Error('error subscribeToWaitingList');
    }
  }

  async unregisterWaitingList(eventId: number) {
    try {
      const response = await this.client.mutate({
        mutation: schemaEvents.unsubscribeToWaitingList,
        variables: { eventId }
      });
      return response?.data?.unsubscribeToWaitingList;
    } catch (err) {
      if (err instanceof ApolloError) {
        throw new Error(
          `No se pudo dar de baja en la lista de espera (evento ${eventId})`
        );
      }
      throw err;
    }
  }

  async getOrganizer() {
    try {
      const response = await this.client.query({
        query: schemaEvents.getOrganizer
      });
      return response?.data?.eventsReservation?.organizer;
    } catch (err) {
      if (err instanceof ApolloError) {
        throw new Error(
          `No se pudo traer a los organizadores. Mensaje: ${err}`
        );
      }
      throw err;
    }
  }
}

export default EventsDataStoreGraphQL;
